export class Constant {
  // Month
  public static readonly MONTHS = [
    { name: 'Tháng Một', value: 1 },
    { name: 'Tháng Hai', value: 2 },
    { name: 'Tháng Ba', value: 3 },
    { name: 'Tháng Tư', value: 4 },
    { name: 'Tháng Năm', value: 5 },
    { name: 'Tháng Sáu', value: 6 },
    { name: 'Tháng Bảy', value: 7 },
    { name: 'Tháng Tám', value: 8 },
    { name: 'Tháng Chín', value: 9 },
    { name: 'Tháng Mười', value: 10 },
    { name: 'Tháng Mười Một', value: 11 },
    { name: 'Tháng Mười Hai', value: 12 },
  ];

}

export class FileConstant {
  // EXCEL
  public static readonly EXCEL_TYPE_1 = 'xls';
  public static readonly EXCEL_MIME_1 = 'application/vnd.ms-excel';

  public static readonly EXCEL_TYPE_2 = 'xlsx';
  public static readonly EXCEL_MIME_2 = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  public static readonly REFRESH_TOTP_SUCCESS = 'Tạo lại thành công TOTP';

// PDF
  public static readonly PDF_TYPE = 'pdf';
  public static readonly PDF_MIME = 'application/pdf';

  // WORD
  public static readonly DOC_TYPE = 'doc';
  public static readonly DOC_MIME = 'application/msword';

  public static readonly DOCX_TYPE = 'docx';
  public static readonly DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  public static readonly VN_REGEX = /^[a-zA-Z ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ ]+$/

  public static readonly NOT_VN_REGEX = /[^a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ ]*/g
}


